import {SERVICE_PEER_ID, VERIFICATION_CODES_BOT_ID} from '@appManagers/constants';

/** 可被水位线判定的最小消息形状（Worker / 主线程共用） */
export type CorpHideableMessage = {
  peerId?: PeerId,
  fromId?: PeerId,
  date?: number,
  pFlags?: {out?: boolean}
};

export function isCorpServicePeer(peerId: PeerId | undefined): boolean {
  return peerId === SERVICE_PEER_ID || peerId === VERIFICATION_CODES_BOT_ID;
}

/**
 * 是否应在员工端隐藏该条消息。
 * 仅隐藏：服务号/验证码会话 + 入站系统来源 + date >= 开启水位线（unix 秒）。
 * 历史（date < since）与员工出站消息一律放行。
 */
export function isCorpServiceMessageHidden(
  message: CorpHideableMessage | undefined | null,
  sinceSec: number | undefined | null
): boolean {
  if(!message || !sinceSec) return false;
  const peerId = message.peerId;
  if(!isCorpServicePeer(peerId)) return false;
  if(message.pFlags?.out) return false;
  // 系统消息来自会话本身（与 messageForReply 验证码打码判定一致）
  if(message.fromId !== undefined && message.fromId !== peerId) return false;
  const date = message.date || 0;
  return date >= sinceSec;
}
